var style = document.createElement("style");
style.setAttribute("less", "responsive-child.less");
style.innerHTML = "[is=responsive-body],\nresponsive-child {\n  margin: 0;\n  padding: 0.1px 0;\n  display: block;\n}\n";
document.head.insertBefore(style, document.head.firstElementChild);
